import { Flex, Spinner } from '@televet/kibble-ui';
import React from 'react';

const LoadingIndicator = (): JSX.Element => {
  return (
    <Flex align="center" justify="center" zIndex={1}>
      <Spinner />
    </Flex>
  );
};

export default LoadingIndicator;
